// Showcase Category Component
// Custom web component for displaying a complete showcase category

import type { ShowcaseCategory } from "./showcase-config.ts";
import type { ShowcaseCategoryHeader } from "./showcase-category-header.ts";
import type { ShowcaseProjectCard } from "./showcase-project-card.ts";

class ShowcaseCategoryComponent extends HTMLElement {
  private config: ShowcaseCategory | null = null;
  private hasRendered: boolean = false;

  connectedCallback() {
    const categoryId = this.getAttribute("category-id");
    if (!categoryId) {
      console.error("ShowcaseCategory: category-id attribute is required");
      return;
    }
    // Don't render yet, wait for config
  }

  setConfig(config: ShowcaseCategory) {
    this.config = config;
    if (!this.hasRendered) {
      this.render();
      this.hasRendered = true;
    }
  }

  private render() {
    if (!this.config) return;

    this.innerHTML = `
      <div class="mb-20">
        <div id="category-header-${this.config.id}"></div>
        <div id="category-projects-${this.config.id}"></div>
      </div>
    `;

    // Render category header
    setTimeout(() => {
      const headerContainer = this.querySelector(`#category-header-${this.config!.id}`);
      if (headerContainer) {
        const headerElement = document.createElement("showcase-category-header") as ShowcaseCategoryHeader;
        headerElement.setConfig(this.config!);
        headerContainer.appendChild(headerElement);
      }

      // Render projects
      const projectsContainer = this.querySelector(`#category-projects-${this.config!.id}`);
      if (projectsContainer) {
        this.config!.projects.forEach((project) => {
          const projectElement = document.createElement("showcase-project-card") as ShowcaseProjectCard;
          projectElement.setAttribute("project-id", project.id);
          projectElement.setConfig(project);
          projectsContainer.appendChild(projectElement);
        });
      }
    }, 0);
  }
}

customElements.define("showcase-category", ShowcaseCategoryComponent);

export { ShowcaseCategoryComponent };

